"use strict";

// 3rd party dependency

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require("angular");

var _angular2 = _interopRequireDefault(_angular);

var _fleetview = require("./fleetview.config");

var _fleetview2 = _interopRequireDefault(_fleetview);

var _fleetview3 = require("./fleetview.dashboard");

var _fleetview4 = _interopRequireDefault(_fleetview3);

var _fleetview5 = require("./fleetview.api");

var _fleetview6 = _interopRequireDefault(_fleetview5);

var _routereporter = require("./routereporter.config");

var _routereporter2 = _interopRequireDefault(_routereporter);

var _routereporter3 = require("./routereporter.api");

var _routereporter4 = _interopRequireDefault(_routereporter3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module("alk.fleetview", []).constant("alk.fleetview.config", _fleetview2.default).service("FleetViewDashboard", _fleetview4.default).service("FleetViewAPI", _fleetview6.default).constant("alk.routereporter.config", _routereporter2.default).service("RouteReporterAPI", _routereporter4.default).name;

// alk dependency


// WEBPACK FOOTER //
// ./app/alk-fleetview/index.js